import * as React from 'react';
import IntroCard from '../../Components/IntroCard/IntroCard';

class Jumbotron extends React.Component {
  render() {
    return (
      <div className="jumbotron-container">
        <div className="jumbotron-wrapper">
          <div className="cover-image">
            <img src="/cover-image.jpg" alt="This is my cover pic."/>
          </div>
          <IntroCard />
        </div>
      </div>
    )
  }
}

export default Jumbotron;
